// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","354":"41155975","377":"component---src-pages-sidebar-tsx","563":"cb355538"}[chunkId] + "-" + {"245":"b11b1ad61488a56e1a36","354":"46ea26211ce0c2ac7e6c","377":"1b738ebf1e8d37791003","563":"bf7b874fcfd0e113e85c"}[chunkId] + ".js";
};